import { Flex, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { AiOutlineBarChart } from 'react-icons/ai'
import { RiCloseLine } from 'react-icons/ri'

import { IGraphicValues } from '@base/@types/providers/Otb/FollowUpProvider'

interface IOpenOrCloseChartButton {
  openText: string
  closeText: string
  isGraphic: boolean
  graphicValue: IGraphicValues[]
  setIsGraphic: (value: boolean) => void
}

const OpenOrCloseChartButton: FC<IOpenOrCloseChartButton> = ({
  openText,
  closeText,
  isGraphic,
  graphicValue,
  setIsGraphic
}) => {
  return (
    <>
      {graphicValue?.length > 0 && (
        <Flex alignItems="center">
          <Text marginRight={2} fontSize="sm">
            {`${isGraphic ? closeText : openText}`}
          </Text>

          <Flex
            id="email-alerts"
            width={4}
            height={4}
            fontSize={14}
            alignItems="center"
            justifyContent="center"
            background={'yellow.400'}
            borderRadius={2}
            boxShadow="xs"
            cursor="pointer"
            transition="all ease .2s"
            _hover={{
              background: 'yellow.500'
            }}
            onClick={() => setIsGraphic(!isGraphic)}
          >
            {isGraphic ? <RiCloseLine /> : <AiOutlineBarChart />}
          </Flex>
        </Flex>
      )}
    </>
  )
}

export default OpenOrCloseChartButton
